<div class="scrollable-dialog">

    <form name="ttsForm" [formGroup]="ttsForm" class="min-w-[350px] min-h-[700px] flex-col justify-between justify-items-start" >
        <h1 mat-dialog-title>
            Create Text To Speech Prompt
        </h1>
        <mat-tab-group #tabGroup>
            <mat-tab>
                <ng-template mat-tab-label>
                    Single
                </ng-template>
                <mat-form-field hintLabel="Max 3000 characters" appearance="outline" floatLabel="auto" class="w-full">
                    <mat-label>Text To Speech Message</mat-label>
                    <textarea cols="50" rows="7" formControlName="ttsMessage"  matInput #input maxlength="3000" (change)="messageChange()"></textarea>
                    <mat-hint align="end">{{input.value?.length || 0}}/3000</mat-hint>
                </mat-form-field>
                <mat-form-field class="fuse-mat-no-subscript w-full" >
                    <mat-label>FileName</mat-label>
                    <input matInput
                           formControlName="ttsFileName">
                </mat-form-field>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    Multiple
                </ng-template>
                <div class="flex-col">
                    <div>
                        <a  mat-menu-item href="data:application/octet-stream,filePath%2CpromptMessage%2CvoiceId%0A/Folder/File.wav%2CMessage%20To%20Speak%2Coptional(Stephen-generative%20)%0A" download="Batch Prompt Template.csv">
                            <mat-icon>cloud_download</mat-icon> Download Template
                        </a>
                    </div>
<!--                    <input type="file" accept=".csv" style="display: none;" (change)="handleCSVFile($event)">-->
                    <button mat-menu-item aria-label="Upload Batch" matTooltip="Batch Files" (click)="fileInput.click()">
                        <input hidden (change)="handleCSVFile($event)" #fileInput type="file">
                        <mat-icon>cloud_upload</mat-icon>
                        <span>Upload Batch File </span>
                    </button>
                    <div>
                        <p><b>File MUST be CSV format</b><br>
                            File Count: {{fileLoadCount}}<br/>
                            Word Count: {{wordCount}}</p>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>

        <div>
            <mat-form-field class="fuse-mat-no-subscript w-full" >
                <mat-label>Language</mat-label>
                <mat-select placeholder="Language" formControlName="ttsLanguage"
                            (valueChange)="languageChange($event)" >
                    <mat-option *ngFor="let language of pollyLanguages"
                                [value]="language.languageCode">{{language.languageName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="fuse-mat-no-subscript w-full" >
                <mat-label>Voice</mat-label>
                <mat-select placeholder="Voice" formControlName="ttsVoice"
                            (valueChange)="voiceChange($event)">
                    <mat-option *ngFor="let voice of filteredVoices" [value]="voice">{{voice.name}} </mat-option>
                </mat-select>
            </mat-form-field>

            <div>
                <mat-checkbox formControlName="isDefaultVoice" class="remember-me" aria-label="Default" (change)="isDefault = !isDefault">
                    Default
                </mat-checkbox>
            </div>

        </div>
        <div fxLayout="row" fxLayoutAlign="space-around center">
            <button mat-raised-button color="accent" (click)="playPolly()"
                    [disabled]="!(pollyProcessList.length > 0) &&
                        (ttsForm.get('ttsMessage').value !== '' && ttsForm.get('ttsVoice').value !== '') === false">
                <mat-icon>play_arrow</mat-icon>
                &nbsp;Play
            </button>
        </div>
    </form>
    <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-around center">
        <button mat-raised-button (click)="onDismiss()">
            <mat-icon>cancel</mat-icon>&nbsp;Cancel
        </button>
        <button mat-raised-button color="primary"
                (click)="onSave()"
                [disabled]="!(pollyProcessList.length > 0) &&
                        (ttsForm.get('ttsMessage').value !== '' && ttsForm.get('ttsVoice').value !== '' && ttsForm.get('ttsFileName').value !== '') === false">
            <mat-icon>save</mat-icon>&nbsp; Save</button>
    </mat-dialog-actions>

</div>
